import React, { Component } from 'react';
import * as XLSX from 'xlsx';
import _ from 'lodash';
import Validator from 'validatorjs';
import { Row, Col, Modal } from 'react-bootstrap';

import Loading from '../../../facturotopia/loading/Loading';
import ResponseError from '../../../shared/responses/ResponseError';
import ResponseResult from '../../../shared/responses/ResponseResult';

class SucursalesLoadFile extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      progress: 0,
      show: props.show,
      validator: new Validator({}, this.rules),
    };
  }

  get rules() {
    return {
      'data.*.id': ['required', 'string', 'min:2'],
      'data.*.sucursal': ['required', 'string', 'min:2'],
      'data.*.ciudad': ['string', 'min:2', 'max:50'],
      'data.*.iva_fronterizo': ['required', 'in:SI,NO'],
      'data.*.codigo_postal': ['required', 'string', 'min:5', 'max:5'],
    };
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  }

  handleOnReadFile = (event) => {
    this.setState({
      progress: 1,
    });

    const file = event.target.files[0];
    const fileReader = new FileReader();

    try {
      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e) => {
        const bufferArray = e.target.result;
        const xlsx = XLSX.read(bufferArray, { type: 'buffer' });
        const name = xlsx.SheetNames[0];
        const sheet = xlsx.Sheets[name];

        let data = XLSX.utils.sheet_to_json(sheet);

        let duplicates = [];
        data = this.parseToString(data);
        [data, duplicates] = this.duplicates(data);

        const validator = this.validate({ data });
        const isValid = validator.passes();

        if (isValid) {
          this.setState({ data, duplicates });

          this.handleOnAdd(data, duplicates);
        } else {
          let errors = _.map(validator.errors.all(), (error, key) => {
            const fila = key.split('.');

            return _.map(error, (value) => {
              let message = value.replace(`${fila[0]}.${fila[1]}.`, '');
              message = `Fila ${parseInt(fila[1]) + 2}: ` + message;

              return { message: message };
            });
          });

          errors = errors.flat();

          const error = {
            message: 'Error de validación. Corrige tu archivo y subelo de nuevo.',
            errors: [...errors],
          };

          this.setState({
            showError: true,
            error: error,
          });
        }
      };

      event.target.value = null;
    } catch (error) {}
  };

  parseToString = (data = {}) => {
    return Object.entries(data).map(([key, value]) => {
      let transform = {};

      for (const key in value) {
        if (Object.hasOwnProperty.call(value, key)) {
          transform[key] = value[key].toString();
        }
      }

      return transform;
    });
  };

  duplicates = (data) => {
    let result = [];

    data.forEach(function (item) {
      let id = item['id'];

      if (result[id] === undefined) {
        result[id] = [item];
      } else {
        result[id].push(item);
      }
    });

    let sucursales = [];
    let duplicates = [];

    for (let key in result) {
      sucursales.push(result[key][0]);

      if (result[key].length > 1) {
        duplicates[key] = { cantidad: result[key].length - 1 };
      }
    }

    return [sucursales, duplicates];
  };

  handleOnAdd = (data, duplicates = []) => {
    this.props.onAdd(data);

    const result = {
      message: `Se registraron ${data.length} sucursales.`,
      data,
      duplicates,
    };

    this.setState({
      progress: 100,
      result: result,
      showResult: true,
    });
  };

  handleOnAction = () => {
    this.setState({
      showResult: false,
      showError: false,
    });

    this.handleOnClose();
  };

  handleOnClose = () => {
    this.props.onClose();
  };

  renderResult = () => {
    const { result, data, duplicates } = this.state;

    return (
      <div className="result-container">
        <ResponseResult
          title="Completado"
          result={result}
          onAction={this.handleOnAction}
        >
          {data.map((item) => (
            <p key={item.id}>
              <strong>{item.id}</strong>, <strong>{item.sucursal}</strong>, Frontera:
              <strong>{item.iva_fronterizo}</strong>, CP:<strong>{item.codigo_postal}</strong>
            </p>
          ))}

          {Object.entries(duplicates).map((item) => (
            <p
              key={item[0]}
              className="text-danger"
            >
              Duplicado:{' '}
              <strong>
                {item[0]}, Veces: {item[1]['cantidad']}
              </strong>
            </p>
          ))}
        </ResponseResult>
      </div>
    );
  };

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  render() {
    const { data, progress, showResult, showError, show } = this.state;

    if (progress === 100 && !!showResult) {
      return this.renderResult();
    }

    if (!!showError) {
      return this.renderError();
    }

    return (
      <Modal
        backdrop="static"
        keyboard={false}
        show={show}
        centered={true}
        onHide={this.handleOnClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Subir archivo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <label>
                <input
                  type="file"
                  accept=".csv, .xls, .xlsx"
                  onChange={this.handleOnReadFile}
                />
              </label>

              {progress > 0 && progress < 100 && !!data && (
                <Row>
                  <Col>
                    <Loading className="mt-3 ml-3" />
                  </Col>
                </Row>
              )}

              <div className="p-3">
                <label>Instrucciones.</label>
                <ul className="list-unstyled">
                  <li>
                    1.{' '}
                    <a
                      target="_blank"
                      href="/resources/template-sucursales.xlsx"
                    >
                      Descarga
                    </a>{' '}
                    el template
                  </li>
                  <li>2. Sigue la guía de llenado</li>
                  <li>3. Sube el archivo</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    );
  }
}

export default SucursalesLoadFile;
